var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserUnfollowFill = function SvgUserUnfollowFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.8 14.028v6.974h-9a7.2 7.2 0 0 1 9-6.974M12 12.902a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4s5.4 2.416 5.4 5.4c0 2.983-2.416 5.4-5.4 5.4m6.3 3.227 1.909-1.91 1.273 1.274-1.91 1.909 1.91 1.909-1.273 1.273-1.909-1.91-1.909 1.91-1.273-1.273 1.91-1.91-1.91-1.908 1.273-1.274z"
  })));
};
export default SvgUserUnfollowFill;